package de.xtl.retroguide

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import de.xtl.retroguide.join.invitationSessionCode
import web.window.window

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val initialSessionCode = window.location.pathname.invitationSessionCode()
    ComposeViewport {
        App(
            initialSessionCode = initialSessionCode,
            onDownloadMarkdown = ::downloadMarkdown,
            onShareMarkdown = ::shareMarkdown,
        )
    }
}
